export function isElectronApp() {
  return /Electron/.test(navigator.userAgent);
}

export function getPlatform() {
  if (isElectronApp() && navigator.appVersion.indexOf("Mac") !== -1) {
    return "Electron Mac";
  }
  if (isElectronApp() && navigator.appVersion.indexOf("Win") !== -1) {
    return "Electron Windows";
  }
  if (navigator.appVersion.indexOf("Mac") !== -1) {
    return "Mac";
  }
  if (navigator.appVersion.indexOf("Win") !== -1) {
    return "Windows";
  }
  return "Unknown platform.";
}
